// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__31dQu","footer":"ModalUpdate_footer__1Gcm4"};